import { FC } from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import { DEFAULT_FLAVOUR, FLAVOUR_TITLES } from 'constants/flavours'
import selectFlavour from 'redux/selectors/selectFlavour'
import selectDeviceType from 'redux/selectors/selectDeviceType'
import Dropdown, { DropdownOptionT } from 'components/Dropdown'
import FlavourIcon from './FlavourIcon'
import { Flavour } from 'types/Flavour'

interface FlavourSelectorProps {
  options: Array<DropdownOptionT & { label: Flavour }>
}

const FlavourSelector: FC<FlavourSelectorProps> = ({ options }) => {
  const flavour = useSelector(selectFlavour) ?? DEFAULT_FLAVOUR
  const { isMobile } = useSelector(selectDeviceType)

  return (
    <Dropdown
      align='left'
      options={options}
      showSelectedIcons={false}
      testId='flavour-selector'
      label={() => (
        <div className='w-100 truncate tl flex gap4-half items-center'>
          <FlavourIcon flavour={flavour} bw />
          {!isMobile && FLAVOUR_TITLES[flavour]}
        </div>
      )}
      classes={{
        button: 'bg-white ba br2 b--bright-grey h2 justify-between',
        chevron: 'black',
        menu: 'bg-white',
        option: ({ focus }) => classNames(
          'black no-underline',
          {
            'bg-casper-white': focus,
            'bg-white': !focus
          }
        )
      }}
    />
  )
}

export default FlavourSelector
